'use strict';

var App = require('app');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var FeedbackDialogView = Marionette.ItemView.extend({
    template: require('components/common/templates/feedback_dialog'),
    ui: {
        taContent: '#feedback-content',
        btnSend: '#feedback-send',
        ddlCategory: '#feedback-category',
        chkToUser: '#feedback-to-user',
    },

    events: {
        'keyup @ui.taContent': 'disableButtons',
        'change @ui.ddlCategory': 'disableButtons',
        'click @ui.btnSend': 'send',
    },

    onRender: function () {
        $(this.el).find('.selectpicker').selectpicker();
    },
    initialize: function (data) {
        this.categories = data.categories;
    },
    serializeData: function () {
        var data = { categories: this.categories };
        return data;
    },
    disableButtons: function () {
        this.ui.btnSend.prop('disabled', this.ui.taContent.val() == '' || !parseInt(this.ui.ddlCategory.val()));
    },
    send: function () {
        var req = App.request(
            'feedback:send',
            this.ui.ddlCategory.val(),
            this.ui.taContent.val(),
            this.ui.chkToUser.prop('checked')
        );
        $.when(req).done(function (req) {
            if (req) {
                App.hideModal();
                Notification.show(
                    'success',
                    i18n.TR('Rückmeldung verschickt'),
                    i18n.TR('Ihre Rückmeldung wurde erfolgreich verschickt.')
                );
            } else {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    i18n.TR('Ihre Rückmeldung konnte nicht verschickt werden. Bitte probieren Sie es noch mal.')
                );
            }
        });
    },
});

FeedbackDialogView.show = function () {
    // request categories
    var req = App.request('feedback:categories');
    $.when(req).done(function (req) {
        if (!req || req.toJSON().length == 0) {
            return;
        }
        var c = new FeedbackDialogView({ categories: req.toJSON() });
        App.showModal(c);
    });
};

module.exports = FeedbackDialogView;
